var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinancialServices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00b1cc",
    fillRule: "evenodd",
    d: "M1.32 3.898c-.237 2.842-.163 5.7.222 8.526a.41.41 0 0 0 .819-.016 34.87 34.87 0 0 0-.26-8.533.39.39 0 1 0-.78.023Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00b1cc",
    fillRule: "evenodd",
    d: "M6.927.513c-1.042 11.637.782 9.182.759 8.83A57.6 57.6 0 0 0 7.704.518a.388.388 0 1 0-.777-.005Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00b1cc",
    fillRule: "evenodd",
    d: "M13.036 2.613a19.001 19.001 0 0 0 .094 6.357.41.41 0 0 0 .819-.028 22.72 22.72 0 0 0-.136-6.334.388.388 0 0 0-.777.005Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00b1cc",
    fillRule: "evenodd",
    d: "M18.65 3.46a.408.408 0 1 0 .819-.023c.839-4.238-2-4.71-.819.023Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00b1cc",
    fillRule: "evenodd",
    d: "M1.808 17.488a18.469 18.469 0 0 0 .068 6.02.41.41 0 0 0 .818 0c.297-2 .26-4.035-.109-6.023a.389.389 0 1 0-.777.003Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00b1cc",
    fillRule: "evenodd",
    d: "M7.237 13.766c-.233 2.424-.14 4.87.277 7.269a.41.41 0 0 0 .818-.029 26.323 26.323 0 0 0-.318-7.271.389.389 0 1 0-.777.03Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00b1cc",
    fillRule: "evenodd",
    d: "M13.23 14.07a25.398 25.398 0 0 0 .13 7.669.41.41 0 1 0 .818-.058 39.547 39.547 0 0 0-.172-7.628.389.389 0 0 0-.777.018Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00b1cc",
    fillRule: "evenodd",
    d: "M18.97 9.856a94.965 94.965 0 0 0 .103 13.597.41.41 0 0 0 .818 0 88.34 88.34 0 0 0-.14-13.6.391.391 0 0 0-.78.003Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#82e1f2",
    fillRule: "evenodd",
    d: "M20.213 7.157a22.59 22.59 0 0 0-1.599-.131.394.394 0 1 1-.018-.787 31.978 31.978 0 0 1 4.722-.185c.913-.004.728 1.439.476 3.408a51.806 51.806 0 0 0-.215 1.87.41.41 0 1 1-.818 0c-.096-1.455-.084-1.974-.07-2.6.005-.196.01-.402.011-.651-.285.22-.664.501-1.163.872-.901.67-2.192 1.63-4.022 3.035-2.771 2.127-3.616 3.208-4.267 3.101-.555-.09-.968-1.046-2.314-2.952-3.552 2.487-5.126 3.514-6.646 4.505-1.042.68-2.06 1.344-3.673 2.451a.39.39 0 0 1-.456-.63 214.768 214.768 0 0 1 6.73-4.997c2.764-1.979 3.666-2.933 4.334-2.79.577.123.98 1.068 2.26 2.881 3.104-2.456 5.302-3.913 8.655-6.137l.155-.103c-.88-.032-1.497-.098-2.082-.16Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialServices);
export default __webpack_public_path__ + "static/media/financial-services.5a9becd680600e08f7a270ff23caf5ed.svg";
export { ForwardRef as ReactComponent };